// extracted by mini-css-extract-plugin
export default {"add_button":"_1A-C","floating":"_3XTm"};